import { render, staticRenderFns } from "./video-slider.vue?vue&type=template&id=3a0b866c&scoped=true"
import script from "./video-slider.vue?vue&type=script&lang=js"
export * from "./video-slider.vue?vue&type=script&lang=js"
import style0 from "./video-slider.vue?vue&type=style&index=0&id=3a0b866c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b866c",
  null
  
)

export default component.exports